import { combineReducers } from "redux";

import { chatStore } from "./chat";
import { notificationStore } from "./Notifications";
import { session } from "./session";
import { shiftStore } from "./shift";

export const rootReducer = combineReducers({
  session,
  shiftStore,
  notificationStore,
  chatStore,
});
